import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { RequireAuth } from '../auth';
import {
  Home,
  NotFound,
  SigninCallback,
  ParcelForm,
  ImportFilesPage,
  VisionUploadPage,
} from '../pages';
import { ROUTES } from './constants';

export const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path={ROUTES.SIGNIN_CALLBACK.path}
          element={<SigninCallback />}
        />
        {/* AUTH ROUTES */}
        <Route element={<RequireAuth />}>
          <Route path={ROUTES.HOME.path} element={<Home />} />
          <Route path="/parcel/:id" element={<ParcelForm />} />
          {/* Paths kept as they were so existing week-card links still resolve. */}
          <Route path="/ups-import-upload" element={<ImportFilesPage carrier="ups" />} />
          <Route path="/gls-import-upload" element={<ImportFilesPage carrier="gls" />} />
          <Route path="/fbo-import-upload" element={<ImportFilesPage carrier="fbo" />} />
          <Route path="/dhl-import-upload" element={<ImportFilesPage carrier="dhl" />} />
          <Route path="/vision-upload" element={<VisionUploadPage />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};
